<template>
  <VueChat></VueChat>
</template>

<script>
import VueChat from "@/components/VueChat/index";
export default {
  components: {
    VueChat,
  },
};
</script>

<style lang="scss" scoped>
.chatmain{
    width: 100%;
}
</style>